import React, { useMemo } from 'react';
import { useRegisterCommands, useRegisterPage, usePluginNavigation } from '../hooks';
import type { Command as CommandType } from '../types';
import { useCommandPaletteContext } from '../CommandPaletteContext';

const PLUGIN_ID = 'hello-world-plugin';
const HELLO_PAGE = 'hello';

// ---------------------------------------------------------------------------
// HelloPage — just says hello
// ---------------------------------------------------------------------------

const HelloPage: React.FC = () => {
  const { searchValue } = useCommandPaletteContext();
  return (
    <div style={{ padding: '2rem', textAlign: 'center', color: 'inherit' }}>
      <div>Hello World!</div>
      <div>You typed: {searchValue}</div>
    </div>
  );
};

// ---------------------------------------------------------------------------
// HelloWorldPlugin — registers one global command that opens HelloPage
// ---------------------------------------------------------------------------

export const HelloWorldPlugin: React.FC = () => {
  const { navigateTo } = usePluginNavigation(PLUGIN_ID);

  const globalCommands = useMemo((): CommandType[] => [
    {
      id: 'hello-world',
      label: 'Hello World',
      description: 'Open the Hello World page',
      category: 'Demo',
      keywords: ['hello', 'world', 'demo'],
      primary: {
        id: 'hello-world-action',
        label: 'Open Hello World',
        action: () => navigateTo(HELLO_PAGE, "Say Hello!"),
      },
    },
  ], [navigateTo]);

  useRegisterCommands({ pluginId: PLUGIN_ID, commands: globalCommands });
  useRegisterPage({ pluginId: PLUGIN_ID, pageId: HELLO_PAGE, component: HelloPage });

  return null;
};
